import {
    getUsageRecord,
    listUsageRecords
} from './queries';
import {
    createUsageRecord,
    deleteUsageRecord,
    updateUsageRecord,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateUsageRecord,
    DeleteUsageRecord,
    GetUsageRecord,
    ListUsageRecords,
    UpdateUsageRecord,
    UsageRecord
} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {GetUsageRecordParser,} from '../schemas/index.ts';
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;

export const fetchRecords = async (query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListUsageRecords>>({
                                                                              query: listUsageRecords,
                                                                              variables: {
                                                                                  ...query
                                                                              },
                                                                          });
    return {
        items: response.data?.listUsageRecords.items,
        nextToken: response.data?.listUsageRecords.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetUsageRecord>>({
                                                                            query: getUsageRecord,
                                                                            variables: {id: id},
                                                                        });

    const parsed = GetUsageRecordParser.parse(response)
    return parsed.data?.getUsageRecord;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateUsageRecord>>({
                                                                               query: createUsageRecord,
                                                                               variables: {input: payload},
                                                                           });
    console.debug('in the service response', response);
    return response.data?.createUsageRecord;
};

export const update = async (id: string, record: UsageRecord) => {

    console.debug('IN UPDATE', id, record);

    const response = await client.graphql<GraphQLQuery<UpdateUsageRecord>>({
                                                                               query: (updateUsageRecord),
                                                                               variables: {input: record},
                                                                           });
    return response.data?.updateUsageRecord;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteUsageRecord>>({
                                                                               query: (deleteUsageRecord),
                                                                               variables: {input: {id: id}},

                                                                           });
    return response.data?.deleteUsageRecord;
};
